import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MenuLikeRequestBody, MenuLikeResponse } from "./types";

export class MenuLikeAPI extends BaseAPI<
  MenuLikeRequestBody,
  MenuLikeResponse
> {
  protected route = ApiRoutes.menu.like;
  protected method = RequestMethod.PUT;
}
